import type {
  DailyTacticalReadiness,
  MarketStatusSimple,
} from '../../services/operationsApi';
import Atu2StatusCard from './Atu2StatusCard';

export default function Atu2SafetySummary({ readiness, market }: Props) {
  const safety = readiness.live_order_safety;
  const realMoneyLocked = !safety.real_capital_allowed;
  const brokerLocked = !safety.broker_submit_allowed;
  const schedulerOff = !readiness.flags.scheduler_enabled;
  return (
    <section className="atu2-grid four">
      <Atu2StatusCard
        label="실전 매매 잠금"
        internal="live lock"
        value={brokerLocked && realMoneyLocked ? '잠금 유지' : '주의 필요'}
        detail={`실제 주문 ${safety.live_broker_orders_count}건 · 실제 돈 사용 ${realMoneyLocked ? '0원' : '허용됨'}`}
        tone={brokerLocked && realMoneyLocked ? 'safe' : 'danger'}
      />
      <Atu2StatusCard
        label="자동 실행"
        internal="scheduler"
        value={schedulerOff ? '꺼짐' : '켜짐'}
        detail={schedulerOff ? '별도 승인 전까지 수동 1회 실행만 허용합니다.' : '자동 실행 상태를 다시 확인해야 합니다.'}
        tone={schedulerOff ? 'safe' : 'danger'}
      />
      <Atu2StatusCard
        label="현재 단계"
        internal="cohort mode"
        value={modeLabel(readiness.flags.cohort_mode)}
        detail={`내부값: ${readiness.flags.cohort_mode}`}
        tone={readiness.flags.cohort_mode === 'rehearsal' ? 'info' : 'warn'}
      />
      <Atu2StatusCard
        label="공식 관찰 기간"
        internal="Stage A clock"
        value={readiness.official_stage_clock_started ? '진행 중' : '아직 시작 전'}
        detail="사전 리허설 결과는 4-8주 공식 관찰 기간에 포함하지 않습니다."
        tone={readiness.official_stage_clock_started ? 'info' : 'warn'}
      />
      <Atu2StatusCard
        label="모델 연결"
        internal="real model"
        value={readiness.flags.real_model_enabled ? '켜짐' : '꺼짐'}
        detail="현재는 사전 리허설에서만 실제 모델을 검증합니다."
        tone={readiness.flags.real_model_enabled ? 'info' : 'warn'}
      />
      <Atu2StatusCard
        label="시장 상태"
        internal="/api/market/status"
        value={market.is_open ? '미국장 열림' : '미국장 닫힘'}
        detail={`${market.status_text} · ${market.next_event}`}
        tone={market.is_open ? 'info' : 'warn'}
      />
      <Atu2StatusCard
        label="모델 재현성 감사"
        internal="model rerun audit"
        value={readiness.audit_readiness.weekly_model_rerun_audit_implemented ? '준비됨' : '미구현'}
        detail="같은 판단 근거로 모델을 다시 호출해 구조가 흔들리는지 확인합니다."
        tone={readiness.audit_readiness.weekly_model_rerun_audit_implemented ? 'safe' : 'danger'}
      />
      <Atu2StatusCard
        label="근거 사실 점검"
        internal="fact-check audit"
        value={readiness.audit_readiness.weekly_fact_check_audit_implemented ? '준비됨' : '미구현'}
        detail="뉴스·시세·프리마켓 근거가 저장되고 점검 가능한지 봅니다."
        tone={readiness.audit_readiness.weekly_fact_check_audit_implemented ? 'safe' : 'danger'}
      />
    </section>
  );
}

function modeLabel(mode: string) {
  if (mode === 'rehearsal') return '사전 리허설';
  if (mode === 'official') return '공식 관찰';
  return '배관 테스트';
}

type Props = {
  readiness: DailyTacticalReadiness;
  market: MarketStatusSimple;
};
